import { ArrowRight, MapPin, NavigationArrow } from "@phosphor-icons/react";
import { motion } from "framer-motion";

export const Location = () => (
  <section id="location" className="section location-section" data-testid="location-section">
    <motion.div
      className="location-copy"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.6 }}
    >
      <span className="eyebrow" data-testid="location-label">03 / Our coast</span>
      <h2 data-testid="location-heading">Based at the bend<br />in the Texas coast.</h2>
      <p data-testid="location-description">
        Corpus Christi sits where working waterways, industrial cargo, and the open Gulf meet. Gulf Coast Fleeting is being built here—with a local perspective and a practical understanding of marine schedules.
      </p>
      <div className="location-facts" data-testid="location-facts">
        <div data-testid="location-fact-home-port"><MapPin size={23} weight="fill" /><span>Home port<strong>Corpus Christi, TX</strong></span></div>
        <div data-testid="location-fact-service-area"><NavigationArrow size={23} weight="fill" /><span>Service focus<strong>Texas Gulf Coast</strong></span></div>
      </div>
      <a className="text-link" href="#contact" data-testid="location-start-conversation-link">
        Start a conversation <ArrowRight size={18} weight="bold" />
      </a>
    </motion.div>
    <div className="location-image-wrap" data-testid="location-image-container">
      <img
        src="/assets/viola-turning-basin.jpg"
        alt="Satellite view of Viola Turning Basin at the western end of the Port of Corpus Christi Inner Harbor"
        data-testid="viola-basin-satellite-image"
      />
      <div className="location-image-label" data-testid="location-image-label">Port of Corpus Christi / Inner Harbor</div>
      <div className="coordinates" data-testid="location-coordinates">
        <span>Viola Turning Basin</span>27.8461° N / 97.5207° W
      </div>
      <div className="imagery-credit" data-testid="location-imagery-credit">Satellite imagery · Esri</div>
    </div>
  </section>
);